<template>
  <div class="c-folder-layer">
    <div v-if="node.type === FIG_PARSED_FIELD_TYPES.FRAME || node.type === FIG_PARSED_FIELD_TYPES.CANVAS || node.type === FIG_PARSED_FIELD_TYPES.TEMPLATE">
      <div
        class="row c-folder-layer__folder d-flex align-items-center"
      >
        <div class="col-9 d-flex align-items-center">
          <b-form-checkbox
            class="mr-1"
            :checked="node.data.visible"
            @change="toggleLayer(node)"
          />
          <div
            class="cursor-pointer"
            @click="collapseHandler"
          >
            <b-icon
              icon="triangle-fill"
              class="mr-2"
              :class="{'closed': !visible, 'opened': visible}"
            />
            <b-icon
              v-if="node.type === FIG_PARSED_FIELD_TYPES.CANVAS"
              icon="file-earmark"
            />
            <svg
              v-else
              width="20"
              height="20"
              class="mr-2"
            >
              <use href="/img/icons/sprite.svg#file-folder-svg" />
            </svg>
            {{ node.data.name }}
          </div>
        </div>
      </div>
      <b-collapse :visible="visible">
        <div class="ml-3 mb-2">
          <div
            v-for="child in node.children"
            :key="child.uuid"
          >
            <FigmaFolderLayer
              :node="child"
            />
          </div>
        </div>
      </b-collapse>
    </div>
    <div
      v-else
      class="row"
    >
      <div class="layer--item col-9 d-flex align-items-center position-relative">
        <b-form-checkbox
          class="mr-2"
          :checked="node.data.visible"
          @change="toggleLayer(node)"
        />
        <component
          :is="childComponent(node)"
          :node="node"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
import {FIG_PARSED_FIELD_TYPES} from "@/includes/fig-parser/constants";
import {FIELD_TYPES} from "@frontend/constants/field-types";

import TextLayer from "./FigmaTextLayer.vue";
import ShapeLayer from "./FigmaShapeLayer.vue";
import ImageLayer from "./FigmaImageLayer.vue";
import VectorLayer from "./FigmaVectorLayer.vue";

const { mapActions } = createNamespacedHelpers('figmaLayers')

const LAYER_VIEWS = {
  [FIG_PARSED_FIELD_TYPES.TEXT]: TextLayer,
  [FIG_PARSED_FIELD_TYPES.RECTANGLE]: ShapeLayer,
  [FIG_PARSED_FIELD_TYPES.IMAGE]: ImageLayer,
  [FIG_PARSED_FIELD_TYPES.VECTOR]: VectorLayer,
}

const FigmaFolderLayer = {
  name: "FigmaFolderLayer",
  props: {
    node: {
      type: Object,
      default: () => ({
        name: 'undefined',
        children: []
      })
    }
  },
  data: () => ({
    visible: false,
  }),
  computed: {
    FIG_PARSED_FIELD_TYPES() {
      return FIG_PARSED_FIELD_TYPES
    },
    childComponent() {
      return node => LAYER_VIEWS[node.type] || []
    },
    FIELD_TYPES() {
      return FIELD_TYPES
    },
  },
  methods: {
    ...mapActions([
      'toggleLayer'
    ]),
    collapseHandler() {
      this.visible = !this.visible
    },
  }
}

export default FigmaFolderLayer
</script>

<style scoped lang="scss">
.closed, .opened {
  font-size: 11px;
  transition: transform 0.5s;
}

.closed {
  transform: rotate(90deg);
}

.opened {
  transform: rotate(180deg);
}
</style>
